import Chip, { ChipProps } from './Chip';

export default Chip;
export type { ChipProps };
